import React from 'react';
import classNames from 'classnames';
import Icon, { IconName } from 'app/common/components/controls/icon';
import styles from './UpgradePromptButton.less';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import RouterLink from 'app/common/components/singlespa/router-link';

/**
 * UpgradePromptButton props
 *
 * cta: call to action of prompt, navigates user within the page
 * ctaLink: link for call to action
 * ctaTrackEvent: function expected to fire a trackUe event, fired on click of cta
 * iconName: name of icon
 * isDarkTheme: controls dark theme
 */

interface UpgradePromptButtonProps {
  cta: string;
  ctaLink: string;
  ctaTrackEvent?: () => void;
  iconName: IconName;
  isDarkTheme?: boolean;
}

export const UpgradePromptButton: React.FunctionComponent<
  UpgradePromptButtonProps
> = ({ cta, ctaLink, ctaTrackEvent, iconName, isDarkTheme }) => {
  const onClickCTA = () => {
    if (ctaTrackEvent) {
      ctaTrackEvent();
    }
  };

  const promptClasses = classNames(
    'upgrade-prompt-button',
    styles.upgradePromptButton,
    (isDarkTheme && styles.upgradePromptButtonDarkTheme) ||
      styles.upgradePromptButtonLightTheme,
    isDarkTheme && 'upgrade-prompt-button-dark',
  );

  return (
    <RouterLink href={ctaLink} className={promptClasses} onClick={onClickCTA}>
      <div className={styles.upgradePromptButtonIconBackground}>
        <Icon
          className={styles.upgradePromptButtonIcon}
          name={iconName}
          small={true}
        />
      </div>
      <div className={styles.upgradePromptButtonCTA}>{cta}</div>
    </RouterLink>
  );
};

export const UpgradePromptButtonConnected: React.FunctionComponent<
  UpgradePromptButtonProps
> = (props) => (
  <ComponentWrapper>
    <UpgradePromptButton {...props} />
  </ComponentWrapper>
);
